import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import AlertMessage from "app/components/ui/AlertMessage/AlertMessage";
import { Button } from "app/components/ui/Button/Button";
import SearchModal from "app/features/SearchEngine/components/SearchModal/SearchModal";
import { getCabinFallback } from "app/pages/SmartDP/smartDPSelectors";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import AppGlobalsContext from "app/AppGlobalsContext";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import "./SdpCabinFallbackAlertMessage.scss";

const SdpCabinFallbackAlertMessage = () => {
	const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
	const cabinFallback = useSelector(getCabinFallback);
	const { track } = useAnalytics();
	const { formatMessage } = useIntl();
	const { resolution } = useContext(AppGlobalsContext);
	const isMobile = resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM;

	useEffect(() => {
		if (cabinFallback) {
			track("cabin_premium_economy_warning_displayed", {
				cabinRequested: cabinFallback.cabinRequested,
				cabinReturned: cabinFallback.cabinReturned,
			});
		}
	}, [cabinFallback]);

	if (!cabinFallback) {
		return null;
	}

	const linkButton = (
		<Button
			variant="borderless"
			size="md"
			className="sdp-cabin-fallback-alert-message__link relative-link"
			onClick={() => {
				track("cabin_premium_economy_warning_link_clicked", {
					cabinRequested: cabinFallback.cabinRequested,
					cabinReturned: cabinFallback.cabinReturned,
				});
				setIsSearchModalOpen(true);
			}}
		>
			<FormattedMessage id="sdp.listing.cabin.fallback.warning.link" />
		</Button>
	);

	return (
		<div className="sdp-cabin-fallback-alert-message">
			<AlertMessage
				message={
					<FormattedMessage
						id="sdp.listing.cabin.fallback.warning.message"
						values={{
							cabinRequested: cabinFallback.cabinRequested,
							cabinReturned: cabinFallback.cabinReturned,
							link: isMobile ? "" : linkButton,
						}}
					/>
				}
			>
				{isMobile && linkButton}
			</AlertMessage>
			<SearchModal
				title={formatMessage({ id: "sdp.search.home.input.label" })}
				isOpen={isSearchModalOpen}
				onClose={() => setIsSearchModalOpen(false)}
				initialFocusField="cabin"
			/>
		</div>
	);
};

export default SdpCabinFallbackAlertMessage;
